import React from 'react';

export default function WelcomeModal({ sharedTrees, ownedTree, onExploreShared, onStartOwn }) {
  // Pick the first shared tree to reference
  const sharedTree = sharedTrees[0];

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 300,
      background: 'rgba(44,36,24,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        width: 480, background: '#FDFBF7', borderRadius: 20,
        boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
        fontFamily: "'DM Sans', sans-serif",
        overflow: 'hidden',
      }}>
        {/* Header band */}
        <div style={{
          background: '#2C2418', padding: '28px 32px 24px',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
        }}>
          <img src="/kt_logo.png" alt="Kinship Trees" style={{ width: 52, height: 52, objectFit: 'contain' }} />
          <h2 style={{
            margin: 0, color: '#F5EDE3', fontSize: 22,
            fontFamily: "'Crimson Pro', Georgia, serif", fontWeight: 700, textAlign: 'center',
          }}>
            Welcome to Kinship Trees
          </h2>
        </div>

        {/* Body */}
        <div style={{ padding: '28px 32px' }}>
          {/* Shared tree notice */}
          <div style={{
            background: '#F5EDE3', borderRadius: 12, padding: '16px 18px',
            border: '1.5px solid #E8D8C0', marginBottom: 24,
          }}>
            <p style={{ margin: 0, fontSize: 13, color: '#6B5E4F', lineHeight: 1.55 }}>
              You've been given access to{' '}
              <strong style={{ color: '#2C2418' }}>{sharedTree.name}</strong>.
              You can explore it using the tree switcher at the top of the sidebar.
            </p>
          </div>

          {/* Own tree pitch */}
          <div style={{ marginBottom: 28 }}>
            <h3 style={{
              margin: '0 0 8px', fontSize: 16,
              fontFamily: "'Crimson Pro', Georgia, serif", fontWeight: 700, color: '#2C2418',
            }}>
              You also have your own tree
            </h3>
            <p style={{ margin: 0, fontSize: 13, color: '#6B5E4F', lineHeight: 1.6 }}>
              Every family has two sides. The tree you've just been invited to covers one —
              {ownedTree
                ? <> <strong style={{ color: '#2C2418' }}>{ownedTree.name}</strong> is yours to fill with the other.</>
                : <> your own tree is yours to fill with the other.</>
              }
            </p>
            <p style={{ margin: '10px 0 0', fontSize: 13, color: '#6B5E4F', lineHeight: 1.6 }}>
              Add your parents, grandparents, cousins. Then share it with them — and watch the story grow from both sides.
            </p>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              onClick={onStartOwn}
              style={{
                flex: 1, padding: '13px 0', borderRadius: 10, border: 'none',
                background: 'linear-gradient(135deg, #C4975A 0%, #A07840 100%)',
                color: '#2C2418', fontSize: 14, fontWeight: 700,
                cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
              }}
            >
              Start My Tree
            </button>
            <button
              onClick={onExploreShared}
              style={{
                flex: 1, padding: '13px 0', borderRadius: 10,
                border: '1.5px solid #D5CAB8',
                background: '#fff', color: '#2C2418', fontSize: 14, fontWeight: 600,
                cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
              }}
            >
              Explore {sharedTree.name}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
